import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/pro-solid-svg-icons';
import { faGlobe } from '@fortawesome/pro-regular-svg-icons';

interface ViewToggleProps {
  value: 'map' | 'list';
  onChange: (value: 'map' | 'list') => void;
  showLabel?: boolean;
}

const ViewToggle: React.FC<ViewToggleProps> = ({
  value,
  onChange,
  showLabel = true,
}) => {
  const options: Array<{
    key: 'map' | 'list';
    label: string;
    icon: typeof faGlobe;
  }> = [
    { key: 'map', label: 'Map', icon: faGlobe },
    { key: 'list', label: 'List', icon: faList },
  ];

  return (
    <div className="flex-1 inline-flex flex-col items-start gap-2">
      {showLabel && (
        <div className="text-primary text-sm font-semibold font-['Inter'] leading-tight">
          View
        </div>
      )}
      <div className="relative rounded-full outline outline-1 -outline-offset-1 outline-neutral-300 inline-flex">
        {/* Sliding background indicator */}
        <div
          className="absolute h-full w-1/2 transition-all duration-300 ease-in-out rounded-full bg-sky-600"
          style={{ left: value === 'map' ? '0%' : '50%' }}
        />

        {/* Toggle buttons */}
        {options.map((option) => {
          const isActive = value === option.key;

          return (
            <button
              key={option.key}
              type="button"
              className={`relative px-3.5 py-2 rounded-full flex justify-center items-center gap-2.5 transition-colors duration-300 ${
                isActive ? 'text-white' : 'text-primary'
              }`}
              onClick={() => onChange(option.key)}
              aria-pressed={isActive}
            >
              <div className="flex justify-center items-center gap-1">
                <div className="w-4 h-4 flex items-center justify-center">
                  <Icon
                    icon={option.icon}
                    className={isActive ? 'text-white' : 'text-primary'}
                    size="sm"
                  />
                </div>
                <div
                  className={`text-sm font-semibold font-['Inter'] leading-tight ${
                    isActive ? 'text-white' : 'text-primary'
                  }`}
                >
                  {option.label}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ViewToggle;
